import { Modal, Form, Tooltip } from 'antd';
import React, { useState, useEffect } from 'react';
import { Button, Icon } from '@digital/ui';
import TextArea from 'antd/lib/input/TextArea';
import ListMensagemClausula from './ListMensagemClausula';
import { SalvarComentario } from '../../../api/minuta/ItemClausula';

export interface PropsModalComentario {
  itemId: string;
  contemComentario: boolean;
}

const ModalComentarioClausula = (props: PropsModalComentario) => {
  const { itemId, contemComentario } = props;
  const [recarregarMensagem, setRecarregarMensagem] = useState(false);
  const [exibirModal, setExibirModal] = useState(false);
  const [iconeComentario, setIconeComentario] = useState('');
  const textAreaId = `textAreaId${itemId}`;

  useEffect(() => {
    if (contemComentario === true) {
      MudarIconeAnexo();
    }
  }, []);

  const MudarIconeAnexo = () => {
    setIconeComentario('has-comments');
  };

  const limparCampo = () => {
    const elemento = document.getElementById(textAreaId);
    if (elemento != null) {
      document.getElementById(textAreaId).value = '';
    }
  };

  const getAll = async () => {
    setRecarregarMensagem(!recarregarMensagem);
  };

  const showModal = () => {
    limparCampo();
    setExibirModal(true);
  };

  const handleCancel = () => {
    limparCampo();
    setExibirModal(false);
  };

  const Salvar = (e: any) => {
    const text = document.getElementById(textAreaId).value;
    const form = new FormData();
    form.append('linhaItemId', itemId);
    form.append('mensagem', text);

    SalvarComentario(form).then(data => {
      if (data.valid) {
        limparCampo();
        setRecarregarMensagem(!recarregarMensagem);
        MudarIconeAnexo();
      }
    });
  };

  return (
    <>
      <Tooltip title="Comentários">
        <Button
          onClick={() => {
            getAll();
            showModal();
          }}
          icon="messaging-comments"
          size="large"
          className={iconeComentario}
        />
      </Tooltip>
      <Modal
        title="Comentário"
        className="chat-modal"
        visible={exibirModal}
        onCancel={() => {
          handleCancel();
        }}
        footer={[
          <Button key="submit" type="link" onClick={() => handleCancel()}>
            Fechar
          </Button>,
          <Button key="submit" type="primary" onClick={e => Salvar(e)}>
            Enviar
          </Button>,
        ]}>
        <ListMensagemClausula itemId={itemId} recarregarMensagem={recarregarMensagem} />
        <div className="chat-modal-message-box">
          <Form>
            <Form.Item>
              <TextArea id={textAreaId} placeholder="mensagem" autosize={{ minRows: 3, maxRows: 5 }} maxLength={300}/>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default ModalComentarioClausula;
